import * as React from 'react'
import { Grid } from '@mui/material'
import { useSelector } from 'react-redux'
import Textfield from '../FormsUI/Textfield'
import DateTimePicker from '../FormsUI/DateTimePicker'
import Select from '../FormsUI/Select'
import AutocompletePseudonym from '../Autocomplete/Pseudonym'
import AutocompleteGroupSpecie from '../Autocomplete/FamilySpecie'
import AutocompleteGroupSite from '../Autocomplete/SiteSeccionAcronym'
import _ from 'lodash'

const ItemsContainer = ({ x, s, m, align, editable, variant = 'standard', ...props }) => {
  let child = null
  const lngLat = useSelector(state => state.mapState.marker?.lnglat)
  const TYPE_AUTOCOMPLET_SPECIE = ['family_', 'specie_']
  const TYPE_AUTOCOMPLET_SITE = ['site_', 'section_', 'siteAcronym_']
  const TYPE_AUTOCOMPLET_PSEUDONYM = ['pseudonym_']
  const TYPE_COORDINATES = ['code_', 'longX', 'latY']
  const SITE_COMPLEMENT = ['typeSite_', 'parish_']

  const [propsTextfield, setPropsTextfield] = React.useState(props)

  const otherPropsControl = {
    InputProps: { readOnly: !editable },
    variant: !_.includes(SITE_COMPLEMENT, props.name) ? variant : 'filled',
    size: !_.includes(SITE_COMPLEMENT, props.name) ? undefined : 'small',
    disabled: _.includes(TYPE_COORDINATES, props.name),
  }

  const isSpecieGroup = _.includes(TYPE_AUTOCOMPLET_SPECIE, props.name)
  const isSiteGroup = _.includes(TYPE_AUTOCOMPLET_SITE, props.name)
  const isPseudonym = _.includes(TYPE_AUTOCOMPLET_PSEUDONYM, props.name)

  if (isPseudonym)
    child = <AutocompletePseudonym {...props} editable={editable} variant={variant} />
  if (isSpecieGroup) child = <AutocompleteGroupSpecie {...props} editable={editable} />
  if (isSiteGroup) child = <AutocompleteGroupSite {...props} editable={editable} />
  if (props.options && !isSpecieGroup && !isSiteGroup && !isPseudonym)
    child = <Select {...props} {...otherPropsControl} />
  if (props.date)
    child = (
      <DateTimePicker
        {...props}
        {...otherPropsControl}
        InputProps={{ readOnly: true }}
        disabled
      />
    )

  React.useEffect(() => {
    if (!_.includes(TYPE_COORDINATES, props.name)) return
    if (!Boolean(lngLat?.length)) return
    if (props.name === 'longX') {
      setPropsTextfield({ ...props, initvalue: parseFloat(lngLat?.[0]) })
    }
    if (props.name === 'latY') {
      setPropsTextfield({ ...props, initvalue: parseFloat(lngLat?.[1]) })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lngLat])

  React.useEffect(() => {
    if (props.name === '') return
    if (!Boolean(lngLat?.length)) return
    if (props.name === 'longX') {
      setPropsTextfield({ ...props, initvalue: parseFloat(lngLat?.[0]) })
    }
    if (props.name === 'latY') {
      setPropsTextfield({ ...props, initvalue: parseFloat(lngLat?.[1]) })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.name])

  return (
    <Grid item xs={x} sm={s} md={m} sx={{ textAlignLast: align }}>
      {child ?? <Textfield {...propsTextfield} {...otherPropsControl} />}
    </Grid>
  )
}

export default React.memo(ItemsContainer)
